export default {
  craftsman: {
    338: process.env.REACT_APP_CRAFTSMAN_ADDRESS_TESTNET,
    25: process.env.REACT_APP_CRAFTSMAN_ADDRESS_MAINNET,
  },
  craftsmanV2: {
    338: process.env.REACT_APP_CRAFTSMAN_V2_ADDRESS_TESTNET,
    25: process.env.REACT_APP_CRAFTSMAN_V2_ADDRESS_MAINNET,
  },
  sousChef: {
    338: process.env.REACT_APP_WORKBENCH_ADDRESS_TESTNET, // FIXME env var syrup bar
    25: process.env.REACT_APP_WORKBENCH_ADDRESS_MAINNET,
  },
  lotteryV2: {
    338: '0x5790c3534F30437641541a0FA04C992799602998',
    25: '0x5aF6D33DE2ccEC94efb1bDF8f92Bd58085432d2c',
  },
  multiCall: {
    25: process.env.REACT_APP_MULTI_CALL_ADDRESS_MAINNET,
    338: process.env.REACT_APP_MULTI_CALL_ADDRESS_TESTNET, // FIXME env var multi call address
  },
  pancakeProfile: {
    25: '0xDf4dBf6536201370F95e06A0F8a7a70fE40E388a',
    338: '0x4B683C7E13B6d5D7fd1FeA9530F451954c1A7c8A',
  },
  pancakeRabbits: {
    25: '0xDf7952B35f24aCF7fC0487D01c8d5690a60DBa07',
    338: '0x60935F36e4631F73f0f407e68642144e07aC7f5E',
  },
  bunnyFactory: {
    25: '0xfa249Caa1D16f75fa159F7DFBAc0cC5EaB48CeFf',
    338: '0x707CBF373175fdB601D34eeBF2Cf665d08f01148',
  },
  claimRefund: {
    25: '0xE7e53A7e9E3Cf6b840f167eF69519175c497e149',
    338: '',
  },
  pointCenterIfo: {
    25: '0x3C6919b132462C1FEc572c6300E83191f4F0012a',
    338: '0xd2Ac1B1728Bb1C11ae02AB6e75B76Ae41A2997e3',
  },
  bunnySpecial: {
    25: '0xFee8A195570a18461146F401d6033f5ab3380849',
    338: '0x7b7b1583De1DeB32Ce6605F6deEbF24A0671c17C',
  },
  tradingCompetition: {
    25: '0xd718baa0B1F4f70dcC8458154042120FFE0DEFFA',
    338: '0xC787F45B833721ED3aC46E99b703B3E1E01abb97',
  },
  easterNft: {
    25: '0x23c41D28A239dDCAABd1bb1deF8d057189510066',
    338: '0x24ec6962dbe874F6B67B5C50857565667fA0854F',
  },
  vvsVault: {
    25: process.env.REACT_APP_VVS_VAULT_ADDRESS_MAINNET,
    338: process.env.REACT_APP_VVS_VAULT_ADDRESS_TESTNET, // FIXME env var vvs vault
  },
  predictions: {
    25: '0x18B2A687610328590Bc8F2e5fEdDe3b582A49cdA',
    338: '',
  },
  chainlinkOracle: {
    25: '0xD276fCF34D54A926773c399eBAa772C12ec394aC',
    338: '',
  },
  bunnySpecialCakeVault: {
    25: '0x5B4a770Abe7Eafb2601CA4dF9d73EA99363E60a4',
    338: '',
  },
  bunnySpecialPrediction: {
    25: '0x342c99e9aC24157657095eC69CB04b73257e7A9C',
    338: '',
  },
  bunnySpecialLottery: {
    25: '0x24ED31d31C5868e5a96aA77fdcB890f3511fa0b2',
    338: '0x382cB497110F398F0f152cae82821476AE51c9cF',
  },
  farmAuction: {
    25: '0xb92Ab7c1edcb273AbA24b0656cEb3681654805D2',
    338: '0x3F9602593b4f7C67ab045DB51BbDEa94E40fA9Fe',
  },
  conditionalLiquidity: {
    25: '0x7aBB7FeC89FE7E22F8d0d5657f1cF6B6d27D6AeF',
    338: '0x9C663742d572Fbd28bf75667084a4331326A012b',
  },
  tradingBattle: {
    25: '0xD086a1739A74e0664E1D9c9ddCbC05F66386e98F', // Launch day contract
    338: '0xb4d81998dc30a95681b6C2e1d6a219B5e8A77Efd', // Competition live testing contract
  },
  vvsBar: {
    25: '0x7fE4DB9063b7Dd7ba55313B9c258070bEd2C143A',
    338: '0x99cEEF14F0Db80E6f691AF925cE1b3759cB54ecC',
  },
  vvsBoost: {
    25: '0x990E9683E6Ba5079CdB235838856029A50DAd84c',
    338: '0xE6126D6E6e2779684eFe6251A967fD86a5601AE5',
  },
  zap: {
    25: process.env.REACT_APP_ZAP_ADDRESS_MAINNET, // FIXME env var
    338: process.env.REACT_APP_ZAP_ADDRESS_TESTNET,
  },
  zapEstimator: {
    25: process.env.REACT_APP_ZAP_ESTIMATOR_ADDRESS_MAINNET, // FIXME env var
    338: process.env.REACT_APP_ZAP_ESTIMATOR_ADDRESS_TESTNET,
  },
}
